import ClosedPeriod from "@/domain/restaurant/ClosedPeriod";
import Table from "@/domain/restaurant/Table";
import UtilService from "@/services/UtilService";

export default class Room {
  roomId!: number;
  roomName!: string;
  closedPeriods: ClosedPeriod[] = [];
  restaurantId!: number;
  tables: Table[] = [];
  allowOnlineBookings!: boolean;
  blockedOnlineTimes: string[] = [];

  constructor(jsonObj?: Room) {
    if (jsonObj) {
      Room.update(this, jsonObj);
    }
  }

  static update(toUpdate: Room, changed: Room) {
    toUpdate.roomId = changed.roomId;
    toUpdate.roomName = changed.roomName;
    toUpdate.closedPeriods = changed.closedPeriods;
    toUpdate.restaurantId = changed.restaurantId;
    if (changed.tables != null) toUpdate.tables = changed.tables;
    toUpdate.blockedOnlineTimes = changed.blockedOnlineTimes;
    toUpdate.allowOnlineBookings = changed.allowOnlineBookings;
  }

  static copy(toCopy: Room): Room {
    return new Room(JSON.parse(JSON.stringify(toCopy)));
  }

  static haveDifferences(room1: Room, room2: Room) {
    return !UtilService.equals(room1, room2);
  }

  static isOpenOnDate(room: Room, date: Date): boolean {
    for (let i = 0; i < room.closedPeriods.length; i++) {
      const closedPeriod = room.closedPeriods[i];
      if (
        closedPeriod != null &&
        ClosedPeriod.isActiveOnDate(closedPeriod, date)
      )
        return false;
    }
    return true;
  }

  static getReasonIsClosedOnDate(room: Room, date: Date): string {
    for (let i = 0; i < room.closedPeriods.length; i++) {
      const closedPeriod = room.closedPeriods[i];
      if (
        closedPeriod != null &&
        ClosedPeriod.isActiveOnDate(closedPeriod, date)
      )
        return ClosedPeriod.roomClosedDisplayString(closedPeriod, date, room);
    }
    return "";
  }

  static getLightweightCopyToSend(original: Room, changed: Room): Room {
    const toReturn = new Room();
    Room.update(toReturn, changed);
    delete toReturn.tables;
    delete toReturn.closedPeriods;
    return toReturn;
  }

  static clearIfUnchanged(originalVal: any, newVal: any) {
    if (originalVal === newVal) {
      return null;
    }
    return newVal;
  }

  static RoomByNameAscendingComparator = (room1: Room, room2: Room) => {
    const name1 = room1.roomName.toUpperCase();
    const name2 = room2.roomName.toUpperCase();
    return UtilService.stringComparatorAscending(name1, name2);
  };

  static getRoomColourFromId(roomId: number) {
    return Room.roomColours[roomId % Room.roomColours.length];
  }

  static roomColours = [
    "blue",
    "green",
    "blue lighten-2",
    "grey darken-1",
    "cyan darken-2",
    "deep-purple",
    "brown lighten-2",
    "deep-purple lighten-3",
    "brown",
    "green darken-2"
  ];
}
